import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { AlertService, FeedbackService, NotificationService } from '@app/core';
import { Attachment, Feedback, TypeFeedbackEnum } from '@app/core/models';
import { SHARED_MODULES } from '@app/shared';
import { downloadFile, fileSvg, notNull, safeEmpty } from '@app/shared/utils';
import { first } from 'lodash';
import { switchMap, tap } from 'rxjs';

@Component({
  selector: 'app-modal-review-feedback-list',
  imports: [SHARED_MODULES],
  templateUrl: './modal-review-feedback-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalReviewFeedbackListComponent {
  private readonly _alertService = inject(AlertService);
  private readonly _feedbackService = inject(FeedbackService);
  private readonly _notificationService = inject(NotificationService);
  @Input() public data: Feedback[];
  @Output() public edit = new EventEmitter<Feedback>();
  @Output() public removed = new EventEmitter<Feedback>();
  public typeFeedbackEnum = TypeFeedbackEnum;

  public onEdit(feedback: Feedback) {
    this.edit.emit(feedback);
  }

  public onDelete(feedback: Feedback) {
    this._alertService
      .confirm({ message: 'Deseja realmente apagar este feedback?' })
      .pipe(
        notNull(),
        switchMap(() => this._feedbackService.destroy(feedback.id).pipe(safeEmpty())),
        tap(() => this._notificationService.success('geral.sucesso')),
      )
      .subscribe(() => this.removed.emit(feedback));
  }

  public onGetIcon(feedback: Feedback): string {
    return fileSvg(first(feedback?.attachments)?.extension);
  }

  public onDownloadFile(attachment: Attachment) {
    downloadFile(attachment);
  }
}
